import type { ReactNode } from 'react';

/** One titled block of the endpoint page; the id doubles as an anchor. */
export function EndpointSection({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <section aria-labelledby={id} className="flex flex-col gap-4">
      <h2 id={id} className="scroll-mt-20 text-xl font-semibold tracking-tight">
        {title}
      </h2>
      {children}
    </section>
  );
}
